import {ReviewActionTypes, RoomInfosActionsTypes} from './constants';
import {DescBlockInputShape} from './types';
import {
  TotalPricingActionTypes,
  PayLaterEligibilityActionTypes,
  AvailRoomsActionTypes,
  ValidateCoupomActionTypes,
  PaymentCheckoutActionTypes,
} from './constants';
import {createAction} from '@stencil/hotels-types/src/type-guards';

/* ------- Descblock Input Actions ------- */
export const updateCgDescblockInput = (payload: DescBlockInputShape) =>
  createAction(ReviewActionTypes.UPDATE_DESCBLOCK_INPUT, payload);

/* ------- Total Pricing Actions ------- */

export const updateTotalPricingFetchStatus = ({status}: {status: object}) =>
  createAction(TotalPricingActionTypes.UPDATE_TOTAL_PRICING_FETCH_STATUS, {status});

export const updateTotalPricingData = (data: any) =>
  createAction(TotalPricingActionTypes.UPDATE_TOTAL_PRICING_DATA, {data});

/* ------- Pay Later Eligibility Actions ------- */

export const updatePayLaterEligibilityFetchStatus = ({status}: {status: object}) =>
  createAction(PayLaterEligibilityActionTypes.GET_PAY_LATER_ELIGIBILITY_STATUS, {status});

export const updatePayLaterEligibilityData = (data: any) =>
  createAction(PayLaterEligibilityActionTypes.UPDATE_PAY_LATER_ELIGIBILITY_DATA, {data});

/* ------- Avail Rooms Actions ------- */

export const updateAvailRoomsFetchStatus = ({status}: {status: object}) =>
  createAction(AvailRoomsActionTypes.GET_AVAIL_ROOMS_STATUS, {status});

export const updateAvailRoomsData = (data: any) =>
  createAction(AvailRoomsActionTypes.UPDATE_AVAIL_ROOMS_DATA, {data});

export const resetAvailRoomsData = () => createAction(AvailRoomsActionTypes.RESET_AVAIL_ROOMS_DATA);

/* ------- Room Infos Actions ------- */

export const updateRoomInfosFetchStatus = ({status}: {status: object}) =>
  createAction(RoomInfosActionsTypes.GET_ROOM_INFOS_STATUS, {status});

export const updateRoomInfosData = (data: any) =>
  createAction(RoomInfosActionsTypes.UPDATE_ROOM_INFOS_DATA, {data});

/* ------- Validate Coupon Actions ------- */

export const updateValidateCouponFetchStatus = ({status}: {status: object}) =>
  createAction(ValidateCoupomActionTypes.GET_VALIDATE_COUPON_STATUS, status);

export const updateValidateCouponData = (data: any) =>
  createAction(ValidateCoupomActionTypes.UPDATE_VALIDATE_COUPON_DATA, {data});

export const resetValidateCouponData = () =>
  createAction(ValidateCoupomActionTypes.RESET_VALIDATE_COUPON_DATA);

/* ------- Payment Checkout Actions ------- */

export const updatePaymentCheckoutFetchStatus = ({status}: {status: object}) =>
  createAction(PaymentCheckoutActionTypes.GET_PAYMENT_CHECKOUT_STATUS, {status});

export const updatePaymentCheckoutData = (data: any) =>
  createAction(PaymentCheckoutActionTypes.UPDATE_PAYMENT_CHECKOUT_DATA, {data});

/* ----------- Review Common Actions ---------- */
export const updateBnplData = (data: any) =>
  createAction(ReviewActionTypes.UPDATE_BNPL_DATA, {data});

export const updateFinalPricingData = (data: any) =>
  createAction(ReviewActionTypes.UPDATE_PRICING_DATA, {data});

export const updateHotelPersuasionsData = (data: any) =>
  createAction(ReviewActionTypes.UPDATE_HOTEL_PERSUASIONS, {data});

export const updateGoCashData = (data: any) =>
  createAction(ReviewActionTypes.UPDATE_GOCASH_DATA, {data});

export const updateLoyaltyData = (data: any) =>
  createAction(ReviewActionTypes.UPDATE_LOYALTY_DATA, {data});

export const updateClmData = (data: any) => createAction(ReviewActionTypes.UPDATE_CLM_DATA, {data});

export const resetReviewData = () => createAction(ReviewActionTypes.RESET_DATA);

/* ------- Review Action Types ------- */
export type ReviewAction =
  | ReturnType<typeof updateCgDescblockInput>
  | ReturnType<typeof updateTotalPricingFetchStatus>
  | ReturnType<typeof updateTotalPricingData>
  | ReturnType<typeof updatePayLaterEligibilityFetchStatus>
  | ReturnType<typeof updatePayLaterEligibilityData>
  | ReturnType<typeof updateAvailRoomsFetchStatus>
  | ReturnType<typeof updateAvailRoomsData>
  | ReturnType<typeof resetAvailRoomsData>
  | ReturnType<typeof updateRoomInfosFetchStatus>
  | ReturnType<typeof updateRoomInfosData>
  | ReturnType<typeof updateValidateCouponFetchStatus>
  | ReturnType<typeof updateValidateCouponData>
  | ReturnType<typeof resetValidateCouponData>
  | ReturnType<typeof updatePaymentCheckoutFetchStatus>
  | ReturnType<typeof updatePaymentCheckoutData>
  | ReturnType<typeof updateBnplData>
  | ReturnType<typeof updateFinalPricingData>
  | ReturnType<typeof updateGoCashData>
  | ReturnType<typeof updateLoyaltyData>
  | ReturnType<typeof updateClmData>
  | ReturnType<typeof resetReviewData>
  | ReturnType<typeof updateHotelPersuasionsData>;
